<template>
    <el-card class="box-card">
        <div class="custom-card-header" slot="header">
            <div class="title"><span v-if="isRequired" class="is-required">*</span>{{ cardTitle }}
                <el-tooltip v-if="tooltip" class="item" effect="dark" placement="top">
                        <div slot="content" v-html="tooltip"></div>
                        <i style="color: red;" class="el-icon-warning-outline"></i>
                </el-tooltip>
            </div>
            <div class="btn-container">
                <el-button type="text" v-if="hasTemp" :loading="tempLoading" @click="handleTemp">下载模版</el-button>
                <el-button type="text" v-if="imgValue || imgExampleValue" @click="handlePreview">预览</el-button>
                <el-button type="text" v-if="imgValue && showDel && !disabled" @click="handleDel">删除</el-button>
            </div>
        </div>
        <div class="abnormal-tips">{{showAbnormalFlag ? '证件有异常,请重新上传' : ''}}</div>
        <el-tooltip class="item" :disabled="!disabledTooltip" effect="dark" placement="top">
            <div slot="content" v-html="disabledTooltip"></div>
            <ocr-upload
                :isNewOcrUpload="isNewOcrUpload"
                :flag="flag"
                :ocr="ocr"
                :drag="drag"
                :isBringOut="isBringOut"
                :disabled="disabled"
                :accept="accept"
                :size="size"
                :supplierCode="supplierCode"
                v-loading="uploadLoading"
                @uploadSuccess="handleUploadSuccess"
                @beforeUpload="handleBeforeUpload"
                @uploadFinish="handleUploadFinish"
                @aiCounter="(type, counter) => $emit('aiCounter', type, counter)"
                >
                <div class="upload-img-box" slot="default" v-if="imgValue || imgExampleValue">
                    <el-image v-if="disabled" :src="imgValue || imgExampleValue" :fit="'contain'"></el-image>
                    <el-image v-else :src="imgValue || imgExampleValue" :fit="'contain'"></el-image>
                    <template v-if="label && !imgValue">
                        <div class="shadow-mask">
                            <span class="mask-title">+ 点击上传{{ label }}</span>
                        </div>
                    </template>
                    <slot name="fileName"></slot>
                </div>
                <div class="upload-img-box no-data" v-else>未上传</div>
            </ocr-upload>
        </el-tooltip>
        
    </el-card>
</template>
<script>
import OcrUpload from '../ocrUpload/Index.vue';
export default {
    components: { OcrUpload },
    props: {
        // 当前图片
        imgValue: {
            type: String,
            require: true,
            default: ''
        },
        // 示例图片
        imgExampleValue: {
            type: String,
            require: true,
            default: ''
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        flag: {
            type: [String, Number, Boolean, Object, Array]
        },
        // 可接收字符串见README.md文档
        ocr: {
            type: String,
            default: ''
        },
        isBringOut: {
            type: Boolean,
            default: false
        },
        isNewOcrUpload: {
            type: Boolean,
            default: false
        },
        // 是否可拖拽
        drag: {
            type: Boolean,
            default: false
        },
        // 卡片标题
        cardTitle: {
            type: String,
            require: true,
            default: ''
        },
        accept: {
            type: String,
            default: '.jpg,.jpeg,.png'
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        supplierCode: {
            type: String,
            default: ''
        },
        size: {
            type: Number,
            default() {
                return 20;
            }
        },
        hasTemp: {
            type: Boolean,
            default: false
        },
        // 模板请求接口
        tempRequest: {
            type: Function,
            default: () => {}
        },
        // 显示删除图片按钮
        showDel: {
            type: Boolean,
            default: false
        },
        //展示异常标识
        showAbnormalFlag: {
            type: Boolean,
            default: false
        },
        //标题旁边气泡提示
        tooltip: {
            type: String,
            default: ''
        },
        //禁用时候气泡提示
        disabledTooltip: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            uploadLoading: false, // 上传加载动画
            tempLoading: false, // 下载模板加载
            actualImgUrl: '' // 文件真实地址
        };
    },
    methods: {
        handleDel(){
            this.$emit('delete')
        },
        // 预览
        handlePreview() {
            this.$emit('preview', this.flag.split('#')[1]);
        },
        // 文件上传之前操作
        handleBeforeUpload() {
            this.uploadLoading = true;
        },
        // 文件上传成功回调
        handleUploadSuccess(data) {
            this.$emit('uploadSuccess', data);
        },
        // 上传完成
        handleUploadFinish() {
            setTimeout(() => {
                this.uploadLoading = false;
            }, 200);
        },
        handleTemp() {
            this.tempLoading = true
            this.tempRequest().then(res => {
                if (res && +res.code === 0) {
                    const a = document.createElement('a');
                    a.href = res.data;
                    a.click();
                }
            }).finally(() => { this.tempLoading = false })
        },
    }
};
</script>
<style lang="less">
.upload-disabled .el-upload-dragger {
    cursor: not-allowed;
}

.upload-img-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 170px;
    text-align: center;
    flex-direction: column;

    &.no-data {
        color: #dcdfe6;
    }

    .el-image {
        width: 100%;
        text-align: center;
    }

    .shadow-mask {
        position: absolute;
        inset: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, .3);

        .mask-title {
            padding: 10px 0;
            width: 220px;
            font-size: 16px;
            color: #f00;
            background-color: rgba(255, 255, 255, .8);
            border-radius: 36px;
            line-height: 16px;
        }
    }
}

.box-card {
    .custom-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .el-card__header {
            padding: 5px 15px;
        }
    }

    .is-required {
        margin-right: 4px;
        color: #F96C5F;
    }
    .abnormal-tips{
        color: red;
        height: 16px;
    }
}
</style>